import { CommonSelect } from '@Components/common/CommonSelect';
import styled, { css } from 'styled-components';

export const WalkthroughFormWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.lightBlue};
  min-height: 100vh;
`;
export const InnerWalkthrough = styled.div<{ isDisabled?: boolean }>`
  margin-top: 48px;
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
    `}
`;
export const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const SearchLabel = styled.p`
  font-weight: 500;
  font-size: 2.4rem;
  white-space: nowrap;
  margin-right: 50px;
`;
export const SelectCarSearch = styled(CommonSelect)`
  margin-bottom: 0;
`;
export const ListingBrands = styled.div`
  display: flex;
  gap: 45px 20px;
  flex-wrap: wrap;
  margin: 24px 0 60px;
  justify-content: center;
`;
export const CarMake = styled.div`
  max-width: 104px;
  min-width: 104px;
  max-height: 104px;
  min-height: 104px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  user-select: none;
  cursor: pointer;
`;
export const ListingYears = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
  margin-bottom: 36px;
`;
